// extracted by mini-css-extract-plugin
export var chatHtmlText = "_lh-2";
export var chatLink = "_lh-0";
export var chatText = "_lh-1";